import { render, staticRenderFns } from "./ModalFilterCategories.vue?vue&type=template&id=1c9bb1b2&"
import script from "./ModalFilterCategories.vue?vue&type=script&lang=js&"
export * from "./ModalFilterCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports